var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"left-float gray",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('forget')}}},[_vm._v("Забыли пароль")]),_vm._v(" "),_c('a',{staticClass:"right-float gray",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('register')}}},[_vm._v("Регистрация")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e05b634","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/elements/LoginModalFooter.vue
// module id = 99
// module chunks = 6